import { useEffect, useCallback, useState } from 'react';
// 
import { useRouter, useAuthContext } from 'hooks';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export default function AuthGuard({ children }: Props) {
    const router = useRouter();

    const { authenticated } = useAuthContext();

    const [checked, setChecked] = useState(false);

    const check = useCallback(() => {
        if (!authenticated) {

            const href = `/login`;

            router.replace(href);
        } else {
            setChecked(true);
        }
    }, [authenticated, router]);

    useEffect(() => {
        check();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (!checked) {
        return null;
    }

    return <>{children}</>;
}
